/*
  public async deleteAttachment(
    @Ctx() context: Context,
    @Arg("attachmentUuid", type => String) attachmentUuid: string
 */

export const DELETE_ATTACHMENT_MUTATION = `
    mutation DeleteAttachment($uuid: String!) {
        deleteAttachment(attachmentUuid: $uuid)
    }
`